import { AdministratorDto } from '@/src/models/AdministratorDto';
import { Media } from '@/src/models/MeidaDto';

export class RecyclingCouponDto {
  id: number;
  sponsorName: string;
  onAt: string;
  offAt: string;
  couponMedia: Media;
  createdAt: string;
  deltedAt?: string;
  updatedAt: string;
  isExposed: boolean;
  administrator: AdministratorDto;
  usedCouponCnt: number;
  exposeService: 'APP' | 'WEB';
}
